import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'
import ListMetaData from '../modules/utilities/list/ListMetaData'

const FindManyByTrackerId = (trackerId, listMetaData) => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.TRACKER_ACTIVITY_LOGS.replace(':id', trackerId),
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const TrackerActivityLogService = {
  FindManyByTrackerId
}

export default TrackerActivityLogService
